import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2, AlertCircle, Clock } from "lucide-react";

/**
 * Componente informativo que exibe a legenda visual dos status de importação
 * Segue rigorosamente o design system da plataforma
 * Apenas informativo - não clicável
 */
export function ImportStatusLegend() {
  const statuses = [
    {
      id: "validada",
      name: "VALIDADA",
      description: "Pronta para confirmação",
      icon: CheckCircle2,
      textColor: "text-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-200",
    },
    {
      id: "confirmada",
      name: "CONFIRMADA",
      description: "Importação ativa",
      icon: CheckCircle2,
      textColor: "text-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-200",
    },
    {
      id: "com_erros",
      name: "COM_ERROS",
      description: "Corrija e reenvie",
      icon: AlertCircle,
      textColor: "text-red-600",
      bgColor: "bg-red-50",
      borderColor: "border-red-200",
    },
    {
      id: "bloqueada",
      name: "BLOQUEADA",
      description: "Nova importação disponível em breve",
      icon: Clock,
      textColor: "text-amber-600",
      bgColor: "bg-amber-50",
      borderColor: "border-amber-200",
    },
    {
      id: "rascunho",
      name: "RASCUNHO",
      description: "Processando...",
      icon: AlertCircle,
      textColor: "text-gray-600",
      bgColor: "bg-gray-50",
      borderColor: "border-gray-200",
    },
  ];

  return (
    <Card className="border-blue-200 bg-blue-50">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2 text-blue-900">
          <div className="w-1 h-1 bg-blue-600 rounded-full" />
          Legenda de Status de Importação
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
          {statuses.map((status) => {
            const Icon = status.icon;
            return (
              <div
                key={status.id}
                className={`p-3 rounded-lg border ${status.bgColor} ${status.borderColor}`}
              >
                {/* Ícone e Nome */}
                <div className="flex items-center gap-2 mb-2">
                  <Icon className={`w-4 h-4 ${status.textColor} flex-shrink-0`} />
                  <span className={`text-xs font-semibold ${status.textColor}`}>
                    {status.name}
                  </span>
                </div>

                {/* Descrição */}
                <p className="text-xs text-gray-700 leading-tight">
                  {status.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Nota informativa */}
        <div className="mt-4 p-3 bg-white rounded-lg border border-blue-100">
          <p className="text-xs text-gray-600">
            <span className="font-semibold text-gray-700">Nota:</span> Os status
            VALIDADA e CONFIRMADA compartilham a mesma paleta de cores, pois ambas
            representam estados positivos. A diferença entre elas é apenas textual.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
